<template>
    <div class="title">
        <h1>
            {{title}}
        </h1>
        <h2 v-if="subtitle">
            {{subtitle}}
        </h2>
    </div>
</template>

<script>
export default {
    name:"PageTitle",
    props: ['title', 'subtitle'],
}
</script>

<style lang="scss" scoped>
.title{
    text-align: center;
    margin: 3.2rem auto;
    margin-bottom: 2rem;
}
h1{
    margin: 0;
    font-size: 2.55rem;
    font-weight: 500;
}
h2{
    font-weight: 500;
    font-size: 16px;
    margin: 0;
}
</style>